<template>
    <div>
        <div class="mt-5 mb-2 d-flex">
            <h1 class="ang-heading">Formularz testowy</h1>
        </div>
        <div>
            <div>
                <h3 class="ang-heading mt-5" id="clientFormHeader">
                    <span>To tylko formularz testowy</span>
                </h3>
                <div class="ang-card ang-card--visible">
                    <div>
                        <form id="biznesTestForm" ref="biznesTestForm" method="POST"
                              class="ang-card-body">
                            <div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <p class="ang-card-title mt-3">Wypełnij formularz</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label class="ang-form-label" for="first_name">Podaj zwoje imię</label>
                                            <input type="text" class="ang-form-control" id="first_name" name="first_name"
                                                   required v-model="name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="alert alert-success ang-alert-success mt-3">
                                <div class="mt-3">
                                    <div>Wynik testu nr 1: <span v-if="test1">OK</span><span v-else>FALSE</span></div>
                                </div>
                                <div class="mt-3">
                                    <div>Wynik testu nr 2: <span v-if="test2">OK</span><span v-else>FALSE</span></div>
                                </div>
                                <div class="mt-3">
                                    <div>Wynik testu nr 3: <span v-if="test3">OK</span><span v-else>FALSE</span></div>
                                </div>
                                <div class="mt-3 mb-3">
                                    <div>Wynik testu nr 4: <span v-if="test4">OK</span><span v-else>FALSE</span></div>
                                </div>
                            </div>
                            <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
                                <h5 class="ang-card-title">Wystąpił błąd!</h5>
                                <label class="form-error error">{{error}}</label>
                            </div>
                            <div class="d-flex">
                                <button class="btn btn-lg  ang-button ang-btn-lg" @click.stop.prevent="doTest2">Wykonaj test nr 2</button>
                                <button type="submit" class="btn btn-lg  ang-button ang-btn-lg ml-auto">Wykonaj test nr 3</button>
                            </div>
                        </form>
                    </div>

                </div>
                <div class="deco-2">
                    <div class="parallax-scene">
                        <svg width="291" height="301" class="parallax-move" data-depth="0.4"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.8 301.08">
                            <path d="M181.24 268.83c-31.74-6.2-50.08 15.86-62.26 7.02-11.8-8.57 3.2-30.91-9.95-48.42-12.47-16.6-33.28-6.33-53.6-20.08-27.6-18.68-39.29-71.48-20.51-94.07 24.06-28.93 89.26 2.43 106.9-26.45 9.81-16.07-6.37-32.26 3.89-45.48 17.77-22.9 93.16-8.8 102.43 21.79 7.87 26-38.3 43.14-34.86 82.29 3.09 35.18 42.11 41.11 41.82 75.45-.23 27.1-24.82 55.31-46.76 56.6-10.66.64-11.66-5.63-27.1-8.65z"
                                  fill="#60c3b4"></path>
                        </svg>
                    </div>
                </div>
                <div class="deco-4">
                    <div class="parallax-scene">
                        <svg class="parallax-move" data-depth="0.4" height="226.12" viewBox="0 0 222.922 226.12"
                             width="222.922" xmlns="http://www.w3.org/2000/svg">
                            <path d="M152.318 155.231c-8.283 6.18-21.242 2.146-37.635-3.187-25.472-8.286-23.941-14.048-35.653-14.508-20.199-.793-26.436 16.274-46.978 13.665-2.8-.356-15.594-1.979-20.159-10.578-7.85-14.792 11.33-45.223 36.242-55.391 12.282-5.014 23.97-4.294 44.123-3.05 27.015 1.667 35.371 7.761 46.188 1.495 13.407-7.766 9.779-22.462 20.207-26.726 19.37-7.923 60.748 30.97 54.278 48.263-5.292 14.117-39.544 5.884-51.77 28.451-5.162 9.53-2.022 16.48-8.843 21.566z"
                                  fill="#11A68A"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import api from '@/services/api'
import ajax from '@/services/ajax'
import $ from 'jquery'
export default {
  data () {
    return {
      loading: true,
      test1: false,
      test2: false,
      test3: false,
      test4: false,
      name: null,
      error: null
    }
  },
  name: 'BiznesTest',
  watch: {
    name () {
      if (this.name && this.name.length > 0) {
        this.test4 = true
      }
    }
  },
  mounted () {
    let self = this
    api.get('/consents/Client', {}, function () {
      self.test1 = true
    }, function () {
      self.test1 = false
    })

    this.$nextTick(function () {
      ajax.justValidate($('#biznesTestForm'), function () {
        self.test3 = true
      })
    })
  },
  methods: {
    doTest2 () {
      this.test2 = true
    }
  }
}
</script>

